import React from "react";
import "./LearningTopics.css";

const LearningTopics = () => {
  const topics = [
    "Students",
    "Working Professionals",
    "Job Seekers",
    "Freelancers",
    "Entrepreneurs",
    "Small Business Owners",
    "Marketing Freshers",
    "Social Media Marketers",
    "Content Creators",
    "YouTubers",
    "Bloggers",
    "Influencers",
    "Affiliate Marketers",
    "Homepreneurs",
    "Real Estate Agents",
    "Coaches & Trainers",
    "Local Business Owners",
    "Startup Founders",
  ];

  return (
    <div className="learning-container">
      <h2>Who Should Learn Digital Marketing?</h2>
      <div className="topics-grid">
        {topics.map((topic, index) => (
          <div key={index} className="topic-item">
            <span className="checkmark">&#10004;</span> {topic}
          </div>
        ))}
      </div>
    </div>
  );
};

export default LearningTopics;
